import React, { useEffect, useState, useRef } from 'react';
import { formatNumberDecimals } from '../../GlobalFunc';
import { useWindowSize } from '../../CommonHooks';
import { unitBetText, formatDecimal } from '@/src/components/Racing/Common/Common';
import './index.scss';
const Input = (props) => {
    let {
        hasContainer = true,
        onChange,
        value,
        disabled,
        containerClassName = '',
        className = '',
        maxLength = 13,
        min = 0,
        max = 999999999999,
        maxErrMsg,
        minErrMsg,
        decimals = 2,
        inputMode = 'numeric',
        onFocus,
        onInput,
        onBlur,
        doInnerBlurWhenOnBlur = false,
        onClick,
        need$ = true,
        type = 'text',
        flexibet,
        placeholder = '',
        testid$ = '',
        testid = '',
        style = {},
        name = '',
        ...rest
    } = props;
    if (!onChange && onInput) {
        onChange = onInput;
    }
    const oldVlaueRef = useRef('');
    const { isMobileSize } = useWindowSize();
    const [name1] = useState(name ? name : 'auto' + Math.random());

    useEffect(() => {
        if (value) {
            oldVlaueRef.current = value;
        }
    }, []);
    const onInputOfInner = (e) => {
        let value = e.target.value;
        if (isMobileSize && e.target.getAttribute('data-init') == 1) {
            if (e.nativeEvent.data != null) {
                value = e.nativeEvent.data;
            }
            e.target.setAttribute('data-init', 0);
            e.target.setAttribute('maxLength', maxLength);
        }

        if (/[^\d.]/g.test(value)) {
            value = value.replace(/[^\d.]/g, '');
        }

        if ((inputMode = 'numeric' && value > 0)) {
            if (Number(value) < 1) {
                value = '';
            } else {
                value = parseInt(Number(value)) + '';
            }
        } else if ((inputMode = 'numeric' && value === '.')) {
            value = '';
        }

        if (Number(value) <= 0) {
            onChange('');
            return;
        }

        if ((inputMode = 'decimal' && !isNaN(Number(value)))) {
            const parts = String(value).split('.');
            const integerPart = parts[0];
            if (integerPart.length > 8) {
                return;
            }
            if (!/\.[0-9]{3,}/.test(value)) {
                onChange(value);
            } else {
                onChange(value.substring(0, value.indexOf('.') + 3));
            }
        } else {
            onChange && onChange(value);
        }
    };

    const [isFocus, setIsFocus] = useState(false);

    const onFocusOfInner = (e) => {
        e.target.placeholder = '';
        if (isMobileSize) {
            e.preventDefault();
            e.target.setAttribute('data-init', 1);
            e.target.removeAttribute('maxLength');
            e.target.setSelectionRange(20, 20);
            setTimeout(function () {
                e.target.setSelectionRange(20, 20);
            });
        }
        setIsFocus(true);
        if (e.target.value === '-') {
            onChange('');
        }
        onFocus && onFocus();
    };

    const onBlurOfInner = (e) => {
        e.target.placeholder = placeholder;
        setIsFocus(false);
        if (onBlur) {
            onBlur();
            if (!doInnerBlurWhenOnBlur) {
                return;
            }
        }
        let isErr = false;
        if (isNaN(Number(value)) || Number(value) <= 0) {
            isErr = true;
        } else if (parseFloat(value) < min) {
            isErr = true;
            minErrMsg && alert(minErrMsg);
        } else if (parseFloat(value) > max) {
            isErr = true;
            maxErrMsg && alert(maxErrMsg);
        }
        if (isErr) {
            onChange(oldVlaueRef.current);
        } else {
            onChange(Number(value));
            oldVlaueRef.current = Number(value);
        }
    };
    const onClickOfInner = (e) => {
        if (isMobileSize) {
            e.target.setSelectionRange(20, 20);
            setTimeout(function () {
                e.target.setSelectionRange(20, 20);
            });
        }
        onClick && onClick();
    };
    let showValue =
        !value || isFocus
            ? flexibet
                ? formatDecimal(value, flexibet)
                : value
            : flexibet
            ? unitBetText(value, flexibet)
            : formatNumberDecimals(value, inputMode === 'decimal' ? decimals : 0);
    let inputContent = (
        <input
            name={name1}
            data-testid={testid}
            autoComplete="off"
            maxLength={maxLength}
            type={type}
            inputMode={inputMode}
            disabled={disabled}
            onChange={onInputOfInner}
            onFocus={onFocusOfInner}
            onBlur={onBlurOfInner}
            className={`OfInnerInput ${className}`}
            value={showValue}
            onClick={onClickOfInner}
            style={style}
            {...rest}
        />
    );

    return hasContainer ? (
        <div className={`input-Container ${containerClassName}`}>
            {need$ && <span data-testid={testid$}>$</span>}
            {inputContent}
        </div>
    ) : (
        inputContent
    );
};

export default Input;
